/**
 * Returns number of milliseconds elapsed since January 1, 1970 00:00:00 UTC
 * uses Date.now()
 */
export function dateNow(): number {
  return Date.now();
}
